<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditAttnGroupLine" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="地点" prop="PaAttnGroupLine.position">
            <el-input class="input-item" v-model="formData.PaAttnGroupLine.position"
              :clearable="true" placeholder="地点"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="上午上班时间" prop="PaAttnGroupLine.attnInTime">
            <el-time-select class="input-item" v-model="formData.PaAttnGroupLine.attnInTime"
              :clearable="true" placeholder="上午上班时间" :picker-options="{start: '05:00',step: '00:15',end: '15:30'}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="上午下班时间" prop="PaAttnGroupLine.attnOutTwoTime">
            <el-time-select class="input-item" v-model="formData.PaAttnGroupLine.attnOutTwoTime"
                            :clearable="true" placeholder="上午下班时间" :picker-options="{minTime: formData.PaAttnGroupLine.attnInTime,start: '05:00',step: '00:15',end: '15:30'}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="下午上班时间" prop="PaAttnGroupLine.attnInTwoTime">
            <el-time-select class="input-item" v-model="formData.PaAttnGroupLine.attnInTwoTime"
                            :clearable="true" placeholder="下午上班时间" :picker-options="{minTime: formData.PaAttnGroupLine.attnOutTwoTime,start: '05:00',step: '00:15',end: '15:30'}"
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="下午下班时间" prop="PaAttnGroupLine.attnOutTime">
            <el-time-select class="input-item" v-model="formData.PaAttnGroupLine.attnOutTime"
                            :clearable="true" placeholder="下午上班时间" :picker-options="{minTime: formData.PaAttnGroupLine.attnInTime,start: '00:00',step: '00:15',end: '23:45'}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="可偏差(分钟)" prop="PaAttnGroupLine.attnAllowTime">
            <el-input-number class="input-item" v-model="formData.PaAttnGroupLine.attnAllowTime"
              :clearable="true"
              placeholder="允许偏差(分钟)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="经度" prop="PaAttnGroupLine.longitude">
            <el-input-number class="input-item" v-model="formData.PaAttnGroupLine.longitude"
              :clearable="true"
              placeholder="经度"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="纬度" prop="PaAttnGroupLine.latitude">
            <el-input-number class="input-item" v-model="formData.PaAttnGroupLine.latitude"
              :clearable="true"
              placeholder="纬度"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="半径(米)" prop="PaAttnGroupLine.radius">
            <el-input-number class="input-item" v-model="formData.PaAttnGroupLine.radius"
              :clearable="true"
              placeholder="半径(米)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="详情" prop="PaAttnGroupLine.detail">
            <el-input class="input-item" v-model="formData.PaAttnGroupLine.detail"
              :clearable="true" placeholder="详情"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaAttnGroupLine.remark">
            <el-input class="input-item" v-model="formData.PaAttnGroupLine.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditAttnGroupLine:EditAttnGroupLine:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaAttnGroupLineController, DictionaryController } from '@/api';

export default {
  name: 'EditAttnGroupLine',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaAttnGroupLine: {
          id: undefined,
          attnAllowTime: undefined,
          attnGroupId: undefined,
          attnInTime: undefined,
          attnOutTime: undefined,
          attnInTwoTime: undefined,
          attnOutTwoTime: undefined,
          position: undefined,
          longitude: undefined,
          latitude: undefined,
          radius: undefined,
          detail: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'PaAttnGroupLine.attnInTime': [
          {required: true, message: '请输入上班时间', trigger: 'blur'}
        ],
        'PaAttnGroupLine.attnAllowTime': [
          {required: true, message: '请输入可偏差(分钟)', trigger: 'blur'},
          {type: 'number', message: '可偏差(分钟)只允许输入数字', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'PaAttnGroupLine.attnOutTime': [
          {required: true, message: '请输入下班时间', trigger: 'blur'}
        ],
        'PaAttnGroupLine.radius': [
          {required: true, message: '请输入半径(米)', trigger: 'blur'}
        ],
        'PaAttnGroupLine.position': [
          {required: true, message: '请输入地点', trigger: 'blur'}
        ],
        'PaAttnGroupLine.latitude': [
          {required: true, message: '请输入纬度', trigger: 'blur'}
        ],
        'PaAttnGroupLine.longitude': [
          {required: true, message: '请输入经度', trigger: 'blur'}
        ]
      },
      EditAttnGroupLine: {
        formFilter: {
        },
        formFilterCopy: {
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 更新编辑考勤组行
     */
    refreshEditAttnGroupLine (reloadData = false) {
      this.loadPaAttnGroupLineData().then(res => {
        if (!this.EditAttnGroupLine.isInit) {
          // 初始化下拉数据
        }
        this.EditAttnGroupLine.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditAttnGroupLine.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            ...this.formData.PaAttnGroupLine
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          paAttnGroupLineDto: {
            id: this.id,
            attnAllowTime: this.formData.PaAttnGroupLine.attnAllowTime,
            attnInTime: this.formData.PaAttnGroupLine.attnInTime,
            attnOutTime: this.formData.PaAttnGroupLine.attnOutTime,
            position: this.formData.PaAttnGroupLine.position,
            longitude: this.formData.PaAttnGroupLine.longitude,
            latitude: this.formData.PaAttnGroupLine.latitude,
            radius: this.formData.PaAttnGroupLine.radius,
            detail: this.formData.PaAttnGroupLine.detail,
            remark: this.formData.PaAttnGroupLine.remark,
            attnGroupId: this.formData.PaAttnGroupLine.attnGroupId,
            attnOutTwoTime: this.formData.PaAttnGroupLine.attnOutTwoTime,
            attnInTwoTime: this.formData.PaAttnGroupLine.attnInTwoTime
          }
        };

        PaAttnGroupLineController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    /**
     * 获取考勤组行详细信息
     */
    loadPaAttnGroupLineData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaAttnGroupLine.isDatasourceInit && this.supportCascadeAdd === '0') {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaAttnGroupLineController.view(this, params).then(res => {
            this.formData.PaAttnGroupLine = {...res.data, isDatasourceInit: true};
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaAttnGroupLine: {
          id: undefined,
          attnAllowTime: undefined,
          attnGroupId: undefined,
          attnInTime: undefined,
          attnOutTime: undefined,
          attnInTwoTime: undefined,
          attnOutTwoTime: undefined,
          position: undefined,
          longitude: undefined,
          latitude: undefined,
          radius: undefined,
          detail: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditAttnGroupLine();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaAttnGroupLine = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
